import { LAYOUT_SECTION } from '@adalo/constants'
import getInputObjectFromEditorObject from '../getInputObjectFromEditorObject'
import dashboardBentoBoxes from './layoutSections/dashboardBentoBoxes'
import dashboardMetricBoxes from './layoutSections/dashboardMetricBoxes'
import minimalListsGallery from './layoutSections/minimalListsGallery'
import minimalListsSingleColumn from './layoutSections/minimalListsSingleColumn'
import tableListsInventoryTable from './layoutSections/tableListsInventoryTable'
import tableListsUsersTable from './layoutSections/tableListsUsersTable'
import galleryDense from './layoutSections/galleryDense'

const debugComponents = {
  // picked up from real projects
  dashboardMetricBoxesSection: {
    icon: 'layout-section',
    label: 'dashboardMetricBoxes',
    value: {
      type: LAYOUT_SECTION,
      options: getInputObjectFromEditorObject(dashboardMetricBoxes),
    },
  },
  minimalListsGallerySection: {
    icon: 'layout-section',
    label: 'minimalListsGallery',
    value: {
      type: LAYOUT_SECTION,
      options: getInputObjectFromEditorObject(minimalListsGallery),
    },
  },
  minimalListsSingleColumnSection: {
    icon: 'layout-section',
    label: 'minimalListsSingleColumn',
    value: {
      type: LAYOUT_SECTION,
      options: getInputObjectFromEditorObject(minimalListsSingleColumn),
    },
  },
  tableListsInventoryTableSection: {
    icon: 'layout-section',
    label: 'tableListsInventoryTable',
    value: {
      type: LAYOUT_SECTION,
      options: getInputObjectFromEditorObject(tableListsInventoryTable),
    },
  },
  tableListsUsersTableSection: {
    icon: 'layout-section',
    label: 'tableListsUsersTable',
    value: {
      type: LAYOUT_SECTION,
      options: getInputObjectFromEditorObject(tableListsUsersTable),
    },
  },
}

// TODO(enzo):these additional components may have some issues with positioning since their
// shared layout seems to be way off, so the ghost doesn't look right at the moment.
// It will be fixed later, before fetching them from backend.

const additionalDebugComponents = {
  galleryDenseSection: {
    icon: 'layout-section',
    label: 'galleryDense',
    value: {
      type: LAYOUT_SECTION,
      options: getInputObjectFromEditorObject(galleryDense),
    },
  },
  dashboardBentoBoxesSection: {
    icon: 'layout-section',
    label: 'dashboardBentoBoxes',
    value: {
      type: LAYOUT_SECTION,
      options: getInputObjectFromEditorObject(dashboardBentoBoxes),
    },
  },
}

const INCLUDE_MAIN_DEBUG_COMPONENTS = false
const INCLUDE_EXTRA_DEBUG_COMPONENTS = false

const getDebugComponents = () => {
  let components = INCLUDE_MAIN_DEBUG_COMPONENTS ? debugComponents : {}

  if (INCLUDE_EXTRA_DEBUG_COMPONENTS) {
    components = { ...components, ...additionalDebugComponents }
  }

  return components
}

export default getDebugComponents()
